import { useState } from 'react';
import { ButtonGrey, ButtonWhite } from '../../components/shared/Buttons';
import { FormRow } from '../../components/shared/InputRow';
import { Modal, ModalProps } from '../../components/shared/Modal';
import toast from 'react-hot-toast';
import { useApiMutation } from '../../scripts/api/api_v2';
import { File } from '../../components/shared/File';

export function ModalImportCards({ closeModal }: ModalProps) {
	const [saving, setSaving] = useState<'saving' | 'saved' | 'unsaved'>('unsaved');
	const [formState, setFormState] = useState<string | undefined>(undefined);
	const [fileName, setFileName] = useState<string | undefined>(undefined);

	const { fetchData: postSaleAPI } = useApiMutation('card.add');

	const readCSV = (data: FileList | null) => {
		const file = data?.[0];
		if (!file) return;
		const reader = new FileReader();
		reader.onload = () => {
			const textResult = reader.result as string;
			setFormState(textResult);
			console.log(textResult);
			setFileName(file.name);
		};

		reader.readAsText(file);
	};

	const onClickSave = async () => {
		try {
			if (!formState) return;
			setSaving('saving');

			const savedSaleRes = await postSaleAPI({
				body: { importCSV: formState },
			});
			if (!savedSaleRes?.success) {
				toast.error(savedSaleRes?.error ?? 'Failed to import!');
				setSaving('unsaved');
				return;
			}
			setSaving('saved');
		} catch (err) {
			console.error(err);
			setSaving('unsaved');
		}
	};

	const onClickRefresh = () => {
		window.location.reload();
	};

	const onClickDownloadTemplate = () => {
		const csvContent = `cardID,site,email\n,,`;

		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

		const url = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', 'data.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<Modal title="Import Card Profiles" closeModal={closeModal}>
			<FormRow>
				<File
					typeText="Import CSV"
					onFileDrop={readCSV}
					fileTypes={['.csv']}
					fileSelected={fileName}
					disabled={saving !== 'unsaved'}
				/>
			</FormRow>
			<FormRow>
				<ButtonGrey onClick={onClickDownloadTemplate}>Download Template</ButtonGrey>
			</FormRow>

			<FormRow>
				<ButtonGrey disabled={saving === 'saving'} onClick={closeModal}>
					Cancel
				</ButtonGrey>
				{saving === 'saved' ? (
					<ButtonWhite onClick={onClickRefresh}>Refresh Page</ButtonWhite>
				) : (
					<ButtonWhite disabled={saving !== 'unsaved'} onClick={onClickSave}>
						Add Cards
					</ButtonWhite>
				)}
			</FormRow>
		</Modal>
	);
}
